export enum ConfirmationDialogEnums {
    WARNING = 'warning',
    ERROR = 'error_outline',
    EMAIL = 'email'
}
